import { useCallback } from 'react'
import { CreditApplication } from '_gql'

import { useAuth } from '@sputnik/auth'
import useGetCreditAppTypes from '@sputnik/hooks/useGetCreditAppTypes'
import { matchEmail } from '@sputnik/utils/dataUtils'

interface UseVerifyPhoneNumberParams {
  salesforceCreditId: CreditApplication['salesforceCreditId']
}

export interface DoesPhoneNumberNeedVerifiedParams {
  verifiedPhoneNumber: string | null
  phoneNumber: string
  authSignerEmail: string
}

export const useVerifyPhoneNumber = ({ salesforceCreditId }: UseVerifyPhoneNumberParams) => {
  const { email: userEmail } = useAuth()
  const { isMajorAccountChange, isMigration, isLoadingCreditAppTypes } = useGetCreditAppTypes({ salesforceCreditId })

  const doesPhoneNumberNeedVerified = useCallback(
    ({ verifiedPhoneNumber, phoneNumber, authSignerEmail }: DoesPhoneNumberNeedVerifiedParams) => {
      if (isLoadingCreditAppTypes) {
        return false
      }

      if (isMajorAccountChange || isMigration) {
        return false
      }

      if (!authSignerEmail || !userEmail || !matchEmail(authSignerEmail, userEmail)) {
        return false
      }

      if (!phoneNumber) {
        return false
      }

      if (!verifiedPhoneNumber) {
        return true
      }

      if (verifiedPhoneNumber !== phoneNumber) {
        return true
      }

      return false
    },
    [isLoadingCreditAppTypes, isMajorAccountChange, isMigration, userEmail],
  )

  return { doesPhoneNumberNeedVerified, isLoadingCreditAppTypes }
}
